// extracted by mini-css-extract-plugin
export default {"recent-tickets-chart__form__metric":"styles_recent-tickets-chart__form__metric__3LL9r"};